var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.pageLoading,
          expression: "pageLoading",
        },
      ],
      staticClass: "ds-container flex gap-20px",
    },
    [
      _vm.currentExamInfo.id
        ? [
            _c(
              "div",
              { staticClass: "ds-aside" },
              [
                _c(
                  "el-upload",
                  {
                    staticClass: "avatar-uploader",
                    attrs: {
                      action: _vm.uploadAction,
                      headers: _vm.headers,
                      "show-file-list": false,
                      "before-upload": _vm.beforeAvatarUpload,
                      "on-success": _vm.handleAvatarSuccess,
                      "on-remove": _vm.handleRemove,
                      disabled: !_vm.isEditRegistrationInfo,
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "tip",
                          fn: function () {
                            return [
                              _c(
                                "div",
                                {
                                  staticClass: "tip-text",
                                  staticStyle: {
                                    "font-size": "12px",
                                    color: "#909399",
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    { staticStyle: { color: "red" } },
                                    [_vm._v("*")]
                                  ),
                                  _c("span", [_vm._v("一寸照")]),
                                  _c("span", [_vm._v("jpg/png/webp格式")]),
                                  _c("span", [_vm._v("大小不能超过500KB")]),
                                ]
                              ),
                            ]
                          },
                          proxy: true,
                        },
                      ],
                      null,
                      false,
                      1400008116
                    ),
                  },
                  [
                    _vm.formData.headImg
                      ? _c("img", {
                          staticClass: "avatar",
                          attrs: { src: _vm.formData.headImg },
                        })
                      : _c("i", {
                          staticClass: "el-icon-plus avatar-uploader-icon",
                        }),
                  ]
                ),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "ds-main flex-1" },
              [
                _vm.isEditRegistrationInfo
                  ? [
                      _c(
                        "ds-form",
                        _vm._b(
                          {
                            ref: "dsFormRef",
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "handle",
                                  fn: function () {
                                    return [
                                      _c(
                                        "el-col",
                                        [
                                          _c(
                                            "el-button",
                                            {
                                              attrs: {
                                                type: "success",
                                                loading: _vm.submitLoading,
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.onSubmit({
                                                    submitStatus: 0,
                                                  })
                                                },
                                              },
                                            },
                                            [_vm._v(" 保存 ")]
                                          ),
                                          _c(
                                            "el-button",
                                            {
                                              attrs: {
                                                type: "primary",
                                                loading: _vm.submitLoading,
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.onSubmit({
                                                    submitStatus: 1,
                                                  })
                                                },
                                              },
                                            },
                                            [_vm._v(" 提交 ")]
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  },
                                  proxy: true,
                                },
                                _vm.formData.regRequirement
                                  ? {
                                      key: "regRequirement",
                                      fn: function ({ formItem }) {
                                        return [
                                          _c(
                                            "el-col",
                                            _vm._b(
                                              {},
                                              "el-col",
                                              formItem.colAttrs,
                                              false
                                            ),
                                            [
                                              _c(
                                                "el-form-item",
                                                _vm._b(
                                                  {},
                                                  "el-form-item",
                                                  formItem,
                                                  false
                                                ),
                                                [
                                                  _c("div", {
                                                    domProps: {
                                                      innerHTML: _vm._s(
                                                        _vm.formData
                                                          .regRequirement
                                                      ),
                                                    },
                                                  }),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                        ]
                                      },
                                    }
                                  : null,
                              ],
                              null,
                              true
                            ),
                            model: {
                              value: _vm.formData,
                              callback: function ($$v) {
                                _vm.formData = $$v
                              },
                              expression: "formData",
                            },
                          },
                          "ds-form",
                          _vm.formConfig,
                          false
                        )
                      ),
                    ]
                  : [
                      _c(
                        "el-form",
                        {
                          staticClass: "readonly-form",
                          attrs: { "label-position": "top" },
                        },
                        [
                          _c(
                            "el-row",
                            { attrs: { gutter: 30 } },
                            _vm._l(
                              _vm.formConfig.formItems,
                              function (formItem) {
                                return _c(
                                  "el-col",
                                  {
                                    key: formItem.prop,
                                    attrs: {
                                      span: _vm.isFullRowItem(formItem)
                                        ? 24
                                        : 12,
                                    },
                                  },
                                  [
                                    _c(
                                      "el-form-item",
                                      { attrs: { label: formItem.label } },
                                      [
                                        formItem.type === "editor"
                                          ? _c("div", {
                                              staticClass: "readonly-value",
                                              domProps: {
                                                innerHTML: _vm._s(
                                                  _vm.registrationInfo[
                                                    formItem.prop
                                                  ] || formItem.valueText
                                                ),
                                              },
                                            })
                                          : formItem.type ===
                                              "singleImageUpload" &&
                                            _vm.isPdfFile(
                                              _vm.registrationInfo[
                                                formItem.prop
                                              ] || formItem.valueText
                                            )
                                          ? _c(
                                              "a",
                                              {
                                                staticClass: "readonly-value",
                                                attrs: {
                                                  href:
                                                    _vm.registrationInfo[
                                                      formItem.prop
                                                    ] || formItem.valueText,
                                                  target: "_blank",
                                                },
                                              },
                                              [_vm._v("查看 PDF 文件")]
                                            )
                                          : formItem.type ===
                                            "singleImageUpload"
                                          ? _c("el-image", {
                                              staticClass:
                                                "preview-image-small",
                                              staticStyle: { width: "150px" },
                                              attrs: {
                                                src:
                                                  _vm.registrationInfo[
                                                    formItem.prop
                                                  ] || formItem.valueText,
                                                "preview-src-list": [
                                                  _vm.registrationInfo[
                                                    formItem.prop
                                                  ] || formItem.valueText,
                                                ],
                                              },
                                            })
                                          : formItem.type === "subTable"
                                          ? _c(
                                              "el-table",
                                              {
                                                staticStyle: { width: "100%" },
                                                attrs: {
                                                  data: _vm.parseSubTableRows(
                                                    formItem.valueJson
                                                  ),
                                                  border: "",
                                                  size: "small",
                                                },
                                              },
                                              [
                                                _c("el-table-column", {
                                                  attrs: {
                                                    type: "index",
                                                    label: "序号",
                                                    width: "60",
                                                    align: "center",
                                                  },
                                                }),
                                                _vm._l(
                                                  formItem.columns || [],
                                                  function (col) {
                                                    return _c(
                                                      "el-table-column",
                                                      {
                                                        key: col.field,
                                                        attrs: {
                                                          label: col.label,
                                                        },
                                                        scopedSlots: _vm._u(
                                                          [
                                                            {
                                                              key: "default",
                                                              fn: function ({
                                                                row,
                                                              }) {
                                                                return [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      row[
                                                                        col
                                                                          .field
                                                                      ] || "-"
                                                                    )
                                                                  ),
                                                                ]
                                                              },
                                                            },
                                                          ],
                                                          null,
                                                          true
                                                        ),
                                                      }
                                                    )
                                                  }
                                                ),
                                              ],
                                              2
                                            )
                                          : _c(
                                              "div",
                                              { staticClass: "readonly-value" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.readonlyValue(formItem)
                                                  )
                                                ),
                                              ]
                                            ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              }
                            ),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
              ],
              2
            ),
          ]
        : _c(
            "div",
            {
              staticStyle: {
                display: "flex",
                "justify-content": "center",
                "align-items": "center",
                "flex-direction": "column",
                "min-height": "calc(100vh - 120px)",
                width: "100%",
              },
            },
            [
              _vm._m(0),
              _c("div", { staticStyle: { "margin-top": "30px" } }, [
                _vm._v("暂无考试可报名！"),
              ]),
            ]
          ),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "print-btn" }, [
      _c("i", {
        staticClass: "el-icon-circle-close",
        staticStyle: { "font-size": "66px" },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }